import React, { useState } from "react";
import { Modal, Divider, TextInput, Button, Box } from "@mantine/core";
import { IconMoodConfuzed, IconMoodSmile } from "@tabler/icons-react";
import ModalHeader from "components/ModalHeader";

import { useApproveLeave } from "api/newLeave/getStatus";

type StatusModalProps = {
  opened: boolean;
  isApproved?: boolean;
  onClose: () => void;
  leaveId: string;
};

function StatusModal({
  opened,
  onClose,
  isApproved,
  leaveId,
}: StatusModalProps) {
  const { mutate: approveLeave } = useApproveLeave();
  console.log(leaveId, "-------------------------->LEAVEID");
  const [reviewedBy, setReviewedBy] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (reviewedBy.trim() === "") {
      setError("Reviewer name is required");
      return;
    }

    setError(null);

    approveLeave({
      leaveId,
      status: isApproved ? "approved" : "rejected",
    });

    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="md"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={isApproved ? "Leave Approved" : "Leave Rejected"}
        onClose={onClose}
        ariaLabel="Close Status modal"
      />
      <Divider mb="md" />

      <Box
        component="form"
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {isApproved ? (
            <IconMoodSmile size={96} stroke={2} color="green" />
          ) : (
            <IconMoodConfuzed size={96} color="red" stroke={2} />
          )}
          <p style={{ fontSize: "20px" }}>
            {isApproved
              ? "Leave has been approved."
              : "Leave has been rejected."}
          </p>
        </Box>

        <TextInput
          label="Status"
          value={isApproved ? "Approved" : "Rejected"}
          disabled
          readOnly
        />

        <TextInput
          label="Review By Reason"
          placeholder="Enter Review By Reason"
          value={reviewedBy}
          onChange={(e) => {
            setReviewedBy(e.currentTarget.value);
            if (error) setError(null);
          }}
          error={error}
        />

        <Button type="submit" fullWidth>
          Submit
        </Button>
      </Box>
    </Modal>
  );
}

export default StatusModal;
